@if (visibleTaxDefinitions.length) { 
    <lib-form-field-container
        [kind]="FormContainerKind.None">

        <ng-content label select="[label]"></ng-content>

        <ng-container readOnly>
            <div #providedReadOnly class="wrapper-content">
                <ng-content select="[readOnly]"></ng-content>
            </div>
            @if (isReadOnly && !isLoadingTaxes) {
                <div class="default-content">
                    @if (!visibleTaxDefinitions.length) {
                        <ng-container i18n="@@FormFieldNoneSelectedLabel">
                            None selected
                        </ng-container>
                    } @else {
                        <div class="d-flex flex-row">
                            <ng-container *ngFor="let tax of visibleTaxDefinitions; let last = last">
                                {{tax.Name}}<div>{{last ? '' : ',&nbsp;'}}</div>
                            </ng-container>
                        </div>
                    }
                </div>
            }
        </ng-container>

        @if (!isReadOnly && !isLoadingTaxes && visibleTaxDefinitions.length) {
            <div>
                <div class="align-items-start gap-2">
                    <lib-checkbox *ngFor="let tax of visibleTaxDefinitions; let i = index"
                        [formControl]="viewControl.controls[i]"
                        [isLoading]="isLoading"
                        (change)="ChangeEvent()">
                        <div class="d-flex align-items-center gap-3">
                            <span>{{tax.Name}} ({{tax.PercentageRate | formatPercent}})</span>
                            @if (autofilledByTaxDefinitionID[tax.ID!]) {
                                <lib-icon [icon]="Icon.Common.AutoAwesome" [size]="IconSize.Small"></lib-icon>
                            }
                        </div>
                    </lib-checkbox>
                </div>
            </div>
        }

    </lib-form-field-container>
}